<template>
  <v-row >
    <v-col cols="12" lg="3" class="d-flex flex-column">
      <card-widget
        icon="mdi-clipboard-account-outline"
        label="Today's Sign-up"
        :value="summaryReport.todaySignup"
      ></card-widget>
    </v-col>
    <v-col cols="12" lg="3">
      <card-widget
        icon="mdi-calendar-check"
        label="Today's Installed/Activated"
        :value="summaryReport.todayActivated"
      ></card-widget>
    </v-col>
    <v-col cols="12" lg="3">
      <card-widget
        icon="mdi-account-clock-outline"
        label="Sign-up pending full payment"
        :value="summaryReport.signUpFullPayment"
      ></card-widget>
    </v-col>
    <v-col cols="12" lg="3">
      <card-widget
        icon="mdi-calendar-multiple-check"
        label="This Month's Installed/Activated"
        :value="summaryReport.monthActivated"
      ></card-widget>
    </v-col>
  </v-row>
</template>

<script>
import CardWidget from "../../../components/CardWidget.vue";
export default {
  name: "DealerSummaryReport",
  components: {
    CardWidget,
  },
  data() {
    return {
      summaryReport: {},
    };
  },

  methods: {
    async getSummaryReport() {
      await this.$api
        .get("/acquisition/report?report=dealer-top-bar")
        .then((response) => {
          const data = response.data.data;
          // console.log(response)
          this.summaryReport = data;
          // console.log("top bar", data)
          this.$store.dispatch("addDealerSummaryReport", data);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    formatNum(num = 0) {
      if (num > 0) {
        return num.toLocaleString();
      }

      return 0;
    },
  },

  mounted() {
    this.getSummaryReport();
  },
  computed: {
    // userRole() {
    //   return this.$store.getters.userRole;
    // },
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
